import { createEnumFromKeys, type EnumFromKeys } from "@mcwd/typescript-type-guards";

export const TranslationNamespace = [
  "company-sizes",
  "countries",
  "states",
  "departments",
  "submit-button-text",
  "form-labels",
  "form-validation",
  "industries",
  "main-solutions",
  "post-submit-text",
  "form-heading-text",
  "contact-post-submit",
  "custom-translations",
] as const;
export type TranslationNamespace = (typeof TranslationNamespace)[number];

export type TranslationNamespaceEnum = EnumFromKeys<TranslationNamespace, true>;
export const TranslationNamespaceEnum = createEnumFromKeys(TranslationNamespace, true);
